var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.getMainClass() }, [
    _c(
      "div",
      { staticClass: "content-title-body bg-blue-dk" },
      [
        _c("div", { staticClass: "controls" }, [
          _c("div", { staticClass: "control-label" }, [
            _c("small", { class: _vm.getLabelClass() }, [
              _vm._v(_vm._s(_vm.label))
            ])
          ]),
          _vm._v(" "),
          _vm.deviceType === "mobile" && !_vm.noScroll
            ? _c("div", { staticClass: "scroll-handle" }, [
                !_vm.isScrolled
                  ? _c(
                      "div",
                      { staticClass: "control", on: { click: _vm.scrollUp } },
                      [
                        _c("i", { staticClass: "material-icons md-24" }, [
                          _vm._v("keyboard_arrow_up")
                        ])
                      ]
                    )
                  : _c(
                      "div",
                      { staticClass: "control", on: { click: _vm.scrollDown } },
                      [
                        _c("i", { staticClass: "material-icons md-24" }, [
                          _vm._v("keyboard_arrow_down")
                        ])
                      ]
                    )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "control right", on: { click: _vm.routeClose } },
            [
              _c(
                "i",
                {
                  staticClass: "material-icons md-18",
                  attrs: { title: "close" }
                },
                [_vm._v("close")]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _vm._t("default")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75451be4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75451be4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-title.vue
// module id = null
// module chunks = 